import * as React from 'react';
import * as qs from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchPendingAction } from "../../global/middleware/fetch-middleware";
import { IEpiProps } from '../state-helpers/epi-props';
import { IBaseAppState } from '..';
import { getEpiProps } from '../../global/ducks/epi-api';
import { INameAndEmailRequest } from '../../global/dtos/filterable-list-results-dto';
import { saveNameAndEmail } from '../../global/ducks/filterable-list-api';
import { debounce } from 'lodash';
import { RestrictedContentInputs } from '../../global/components/inputs/restrictedContentForm/restricted-content-inputs';

const PageSize = 20;

interface IStateProps {
    epiProps: IEpiProps,
}

interface IDispatchProps {
    getEpiProps: () => FetchPendingAction;
    saveNameAndEmail: (request: INameAndEmailRequest) => FetchPendingAction;
}

interface IOwnProps {
    contentId: string;
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    name: string;
    email: string;
}

interface IQueryStringParams {
    redirectUrl?: string;
}
class RestrictedContentFormPageApp extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
        }

    }

    componentDidMount() {
        return this.props.getEpiProps().fetch;
    }

    render() {

        return (
            <React.Fragment>

                <div className="row">
                    <RestrictedContentInputs
                        formTitle={this.props.epiProps.formTitle}
                        nameInputLabel={this.props.epiProps.nameInputLabel}
                        namePlaceholder={this.props.epiProps.namePlaceholder}
                        emailInputLabel={this.props.epiProps.emailInputLabel}
                        emailPlaceholder={this.props.epiProps.emailPlaceholder}
                        nameRequiredError={this.props.epiProps.nameRequiredError}
                        emailRequiredError={this.props.epiProps.emailRequiredError}
                        emailInvalidError={this.props.epiProps.emailInvalidError}
                        submitCtaText={this.props.epiProps.submitCtaText}
                        setNameAndEmail={(name: string, email: string) => this.setNameAndEmail(name, email)}
                    />

                </div>
            </React.Fragment>
        );
    }

    saveNameAndEmail = (name: string, email: string) => {
        return this.props.saveNameAndEmail({
            name: name,
            email: email,
        } as INameAndEmailRequest).fetch;
    }

    

    setNameAndEmail = (name: string, email: string) => {
        this.setState({
            name: name,
            email: email
        });
        this.saveNameAndEmail(name, email).then(value => {
            this.redirectToUrl();
        });
    }

    redirectToUrl = () => {
        let queryStringParams: IQueryStringParams = qs.parse(window.location.search);
        if (queryStringParams && queryStringParams.redirectUrl && queryStringParams.redirectUrl != "") {
            window.location.replace(queryStringParams.redirectUrl);
        }
    }

}

const mapStateToProps = (state: IBaseAppState): IStateProps => ({
    epiProps: state.epi.props,
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => bindActionCreators({
    getEpiProps: () => getEpiProps(ownProps.contentId) as any,
    saveNameAndEmail: saveNameAndEmail as any,
}, dispatch)

export const RestrictedContentFormApp = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(RestrictedContentFormPageApp);
